function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6406 3.20313H2.35938",
  stroke: "#5B5B5B",
  strokeWidth: 0.5625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.73438 5.73438V9.10938",
  stroke: "#5B5B5B",
  strokeWidth: 0.5625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.26562 5.73438V9.10938",
  stroke: "#5B5B5B",
  strokeWidth: 0.5625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7969 3.20313V11.2188C10.7969 11.3306 10.7524 11.4379 10.6733 11.5171C10.5942 11.5962 10.4869 11.6406 10.375 11.6406H3.625C3.51311 11.6406 3.40581 11.5962 3.32669 11.5171C3.24757 11.4379 3.20312 11.3306 3.20312 11.2188V3.20313",
  stroke: "#5B5B5B",
  strokeWidth: 0.5625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10938 3.20313V2.35938C9.10938 2.1356 9.02048 1.92099 8.86225 1.76275C8.70401 1.60452 8.4894 1.51563 8.26563 1.51562H5.73438C5.5106 1.51563 5.29599 1.60452 5.13775 1.76275C4.97952 1.92099 4.89062 2.1356 4.89062 2.35938V3.20313",
  stroke: "#5B5B5B",
  strokeWidth: 0.5625,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trash.d6956442.svg";
export { ForwardRef as ReactComponent };